export default [
  {
    id: 1,
    name: 'Midtown',
    address: {
      street: '693 5th Ave',
      street2: '',
      city: 'New York',
      state: 'NY',
      zip: '10022'
    }
  },
]


// WEBPACK FOOTER //
// ./src/data/locations.js